// To avoid typos and collisions
export enum LocalStorageKey {
    userPrefs = "user-prefs",
    seoBanSearchState = "seo-ban-search-state",
    seoSearchFields = "seo-search-fields",
    VipManagementSearchState = "vip-management-search-state",
    creditTransactionViewerState = "credit-transaction-viewer-state",
    AccountDeletionSearchState = "account-deletion-search-state",
    recentSharedUsers = "recent-shared-users",
}
